"use client"

import { useState, useEffect } from "react"
import { useNavigate, useSearchParams, Link } from "react-router-dom"
import { createUserWithEmailAndPassword } from "firebase/auth"
import { auth } from "./Authenticator/firebase"
import { useAuth } from "../context/AuthContext"
import "../styles/landing-styles.css"

// Componente del ícono de Google
function GoogleIcon() {
  return (
    <svg className="landing-google-icon" viewBox="0 0 24 24">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  )
}

// Componente del ícono de ojo (mostrar/ocultar contraseña)
function EyeIcon({ visible }) {
  if (visible) {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    )
  }
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

// Header del landing
function Header() {
  return (
    <header className="landing-header">
      <div className="landing-logo">
        <img src="/logosinnombresinfondo.png" alt="Deitana" className="landing-logo-img" />
        <span className="landing-logo-text">Deitana IA</span>
      </div>
      <div className="landing-nav-actions">
        <Link to="/login" className="landing-btn-contact">Iniciar sesión</Link>
      </div>
    </header>
  )
}

// Card de Registro
function RegisterCard({ 
  email, 
  setEmail, 
  password, 
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword, 
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  error, 
  isLoading, 
  handleSubmit 
}) {
  return (
    <div className="landing-login-card">
      <h2 className="landing-card-title">Crear cuenta</h2>

      {/* Botón de Google (deshabilitado por ahora) */}
      <button className="landing-btn-google" type="button" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
        <GoogleIcon />
        Continuar con Google (próximamente)
      </button>

      <div className="landing-divider">o</div>

      <form onSubmit={handleSubmit}>
        <div className="landing-form-group" style={{ marginBottom: '20px' }}>
          <label className="landing-form-label" htmlFor="email">Correo electrónico</label>
          <input
            type="email"
            id="email"
            className="landing-input"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <div className="landing-form-group" style={{ marginBottom: '20px' }}>
          <label className="landing-form-label" htmlFor="password">Contraseña</label>
          <div className="landing-password-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              className="landing-input"
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              style={{ paddingRight: '48px' }}
            />
            <button
              type="button"
              className="landing-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              disabled={isLoading}
            >
              <EyeIcon visible={showPassword} />
            </button>
          </div>
        </div>

        <div className="landing-form-group" style={{ marginBottom: '20px' }}>
          <label className="landing-form-label" htmlFor="confirmPassword">Confirmar contraseña</label>
          <div className="landing-password-container">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              className="landing-input"
              placeholder="Repite tu contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={isLoading}
              style={{ paddingRight: '48px' }}
            />
            <button
              type="button"
              className="landing-password-toggle"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              aria-label={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              disabled={isLoading}
            >
              <EyeIcon visible={showConfirmPassword} />
            </button>
          </div>
        </div>

        {error && <p className="landing-error-message">{error}</p>}

        <button
          type="submit"
          className="landing-btn-submit"
          disabled={isLoading}
        >
          {isLoading ? "Creando cuenta..." : "Crear cuenta"}
        </button>
      </form>

      <div className="landing-register-link">
        <p>
          ¿Ya tienes una cuenta?{' '}
          <Link to="/login">Iniciar sesión</Link>
        </p>
      </div>

      <p className="landing-privacy-text">
        Al crear una cuenta, aceptas nuestros{" "}
        <a href="/terms" className="landing-privacy-link">Términos de servicio</a>{" "}
        y{" "}
        <a href="/privacy" className="landing-privacy-link">Política de privacidad</a>.
      </p>
    </div>
  )
}

const Register = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { user, loading, needsSetup } = useAuth()
  const [searchParams] = useSearchParams()

  // Si el usuario ya está autenticado, redirigir según su estado
  useEffect(() => {
    if (!loading && user && user.uid) {
      const redirectUrl = searchParams.get('redirect')
      
      if (needsSetup) {
        if (redirectUrl) {
          navigate(`/configuser?redirect=${encodeURIComponent(redirectUrl)}`, { replace: true })
        } else {
          navigate("/configuser", { replace: true })
        }
      } else {
        if (redirectUrl) {
          navigate(redirectUrl, { replace: true })
        } else {
          navigate("/home", { replace: true })
        }
      }
    }
  }, [user, loading, needsSetup, navigate, searchParams])

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div className="landing-loading">
        <p>Cargando...</p>
      </div>
    )
  }

  const validateForm = () => {
    if (!email || !password || !confirmPassword) {
      setError("Todos los campos son obligatorios")
      return false
    }

    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres")
      return false
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden")
      return false
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setError("El formato del email no es válido")
      return false
    }

    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError("")

    if (!validateForm()) {
      setIsLoading(false)
      return
    }

    try {
      console.log("🔐 Creando nueva cuenta Firebase...")
      
      const userCredential = await createUserWithEmailAndPassword(auth, email, password)
      const newUser = userCredential.user
      
      console.log("✅ Usuario creado exitosamente:", newUser.uid)
      console.log("📧 Email del usuario:", newUser.email)
      
    } catch (err) {
      console.error("❌ Error al crear cuenta Firebase:", err)
      
      let errorMessage = "Error al crear la cuenta"
      
      switch (err.code) {
        case 'auth/email-already-in-use':
          errorMessage = "Ya existe una cuenta con este email"
          break
        case 'auth/invalid-email':
          errorMessage = "El formato del email no es válido"
          break
        case 'auth/operation-not-allowed':
          errorMessage = "El registro con email/contraseña no está habilitado"
          break
        case 'auth/weak-password':
          errorMessage = "La contraseña es muy débil. Debe tener al menos 6 caracteres"
          break
        case 'auth/network-request-failed':
          errorMessage = "Error de conexión. Verifica tu internet"
          break
        case 'auth/too-many-requests':
          errorMessage = "Demasiados intentos. Intenta de nuevo más tarde"
          break
        default:
          errorMessage = `Error: ${err.message || "No se pudo crear la cuenta"}`
      }
      
      setError(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="landing-page">
      <Header />
      <main className="landing-main">
        <div className="landing-content-left">
          <h1 className="landing-headline">
            <span className="landing-headline-highlight">Únete</span>
            <br />
            a Deitana
          </h1>
          <p className="landing-subtitle">
            Crea tu cuenta y accede al sistema de gestión más avanzado para semilleros
          </p>
          <RegisterCard
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            showConfirmPassword={showConfirmPassword}
            setShowConfirmPassword={setShowConfirmPassword}
            error={error}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
          />
        </div>
        <div className="landing-content-right">
          <video
            src="/video1.mp4"
            className="landing-hero-image"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </main>
      <Footer />
    </div>
  )
}

// Footer Component
function Footer() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer-container">
        <div className="landing-footer-logo">
          <span className="landing-footer-logo-text">Deitana IA</span>
        </div>
        
        <div className="landing-footer-columns">
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Productos</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana IA</a></li>
              <li><a href="#!">Deitana Code</a></li>
              <li><a href="#!">Iniciar sesión</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Características</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana y Slack</a></li>
              <li><a href="#!">Deitana en Excel</a></li>
              <li><a href="#!">Habilidades</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Modelos</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Opus</a></li>
              <li><a href="#!">Sonnet</a></li>
              <li><a href="#!">Haiku</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Deitana Developer Platform</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Resumen</a></li>
              <li><a href="#!">Documentación para desarrolladores</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Aprender</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Blog</a></li>
              <li><a href="#!">Red de socios de Deitana</a></li>
              <li><a href="#!">Catálogo</a></li>
              <li><a href="#!">Cursos</a></li>
              <li><a href="#!">Casos de uso</a></li>
              <li><a href="#!">Conectores</a></li>
              <li><a href="#!">Ingeniería en Deitana</a></li>
              <li><a href="#!">Eventos</a></li>
              <li><a href="#!">Desarrollado por Deitana</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Empresa</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Deitana</a></li>
            </ul>
          </div>
          
          <div className="landing-footer-column">
            <h4 className="landing-footer-heading">Ayuda y seguridad</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Disponibilidad</a></li>
              <li><a href="#!">Estado</a></li>
              <li><a href="#!">Centro de soporte</a></li>
            </ul>
            
            <h4 className="landing-footer-heading">Términos y políticas</h4>
            <ul className="landing-footer-links">
              <li><a href="#!">Opciones de privacidad</a></li>
              <li><a href="#!">Política de privacidad</a></li>
              <li><a href="#!">Política de divulgación responsable</a></li>
              <li><a href="#!">Términos de servicio: Comercial</a></li>
              <li><a href="#!">Términos de servicio: Consumidor</a></li>
              <li><a href="#!">Política de uso</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="landing-footer-bottom">
        <span className="landing-footer-by">BY DEITANA</span>
        <span className="landing-footer-copyright">© {new Date().getFullYear()} DEITANA PBC</span>
      </div>
    </footer>
  )
}

export default Register
